import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";
import { AgentUserResponse } from "./agent-user-create";

// 原始接口
export interface AgentSetWorkflowResponse {
  message: string;
  agent_id: string;
  workflow: string;
  workflow_address: string;
  updated_at: string;
};

// 请求接口
interface AgentSetWorkflowRequest {
  agentId: string;
  workflow: string;
  workflowAddress: string;
}


export class AgentSetWorkflowData {
  @Required("Workflow cannot be empty")
  @IsString("Workflow must be a string")
  workflow: string;

  @Required("Workflow Address cannot be empty")
  @IsString("Workflow Address must be a string")
  workflowAddress: string;
}

const transformAndValidateAgent = (
  response: AgentSetWorkflowResponse
): AgentSetWorkflowData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentSetWorkflowData);
  } catch (error) {
    console.error("Agent Set Workflow data validation failed:", error.message);
    throw error;
  }
};

/** 更新 Agent 工作流 */
export const agentSetWorkflow = async ({ agentId, workflow, workflowAddress }: AgentSetWorkflowRequest): Promise<AgentSetWorkflowData> => {
  const response = await api.post<AgentSetWorkflowResponse>('/agent/set-workflow', {
    workflow,
    agent_id: agentId,
    workflow_address: workflowAddress,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
